import React, { useEffect, useState } from "react";
import SideNav from './../containers/SideNav';
import Auxilary from './Auxilary';
import Footer from './../containers/Footer';
import Banner from './../components/sections/Banner/Banner';
import ResponsiveNav from './../containers/ResponsiveNav';
import { Link, animateScroll as scroll } from "react-scroll";

const Layout = (props) => {
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            // Show scroll-to-top button when user scrolls down 300px
            setShowScrollTop(window.scrollY > 300);

            // If user has scrolled to bottom (within 100px of bottom)
            if (documentHeight - scrollPosition < 100) {
                window.gtag('event', 'reach_bottom', {
                    'event_category': 'Scroll',
                    'event_label': 'User reached bottom of page'
                });
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        scroll.scrollTo('welcome', {
            duration: 500,
            smooth: true,
            offset: -70
        });
    };

    return (
        <Auxilary>
            <ResponsiveNav />
            <SideNav />
            {/* Content Wrapper to accommodate fixed Sidebar */}
            <div className="md:ml-72 transition-all duration-300">
                <Banner />
                <div className="main-content">
                    <div className="fluid-container">
                        <div className="content-wrapper">
                            {props.children}
                            <Footer />
                        </div>
                    </div>
                </div>
                {showScrollTop && (
                    <div
                        className="sm-up-container"
                        onClick={scrollToTop}
                    >
                        <i className="fa fa-angle-up sm-up"></i>
                    </div>
                )}
            </div>
        </Auxilary>
    );
}

export default Layout;